/**
 * application constants includes static text and router names
 *
 * export {
 *   appConstants
 * }
 */

const appConstants = {
  routePaths: {
    home: '/home',
    results: '/results',
    browse: '/browse',
    logout: '/logout'
  },
  //!Important : Please don't change the order of verticals. This is used to render tabs in result page
  verticals: {
    All: 'All',
    Documents: 'Documents',
    Credentials: 'Credentials',
    People: 'People',
    News: 'News',
    Videos: 'Videos',
    Data: 'Data'
  },
  backendDataSources: {
    elasticOnPremise: 'DiscoverSPOnPremisesR3',
    elasticSPOnline: 'DiscoverSPOnlineR3',
    people: 'DiscoverPeopleR3',
    bestbets_dev: 'discoveraem_dev_read',
    bestbets_qa: 'discoveraem_qa_read',
    people_stg: 'DiscoverPeopleR3_Stg',
    bestbets: 'discoveraem_read'
  },
  nonVerticals:{
    PolicyFinder:'policyfinder',
    Intranet:'Intranet'
  },
  adobeAnalytics: {
    event: 'searchResultClick',
    type: 'other',
    view: 'View',
    preview: 'Preview',
    pageLoadEvents: {
      pageLoadEventName: 'pageView',
      locationInPage: {
        searchResultsPage: 'Discover Search Results',
        browseResultsPage: ' browse search results'
      },
      eyProduct: 'Discover Reimagined',
      eyApp: 'discover-search'
    },
    previewData: {
      eyProduct: 'Discover Reimagined',
      eyApp: 'discover-search',
      controlType: 'link',
      event: 'clickAction',
      name: 'Preview',
      type: 'other',
      language: 'eng_us',
      locationSearch: 'Discover Search Results',
      locationBrowse: 'Browse',
      isPage: 'false',
      iconControl: 'icon',
      languagePreviewIcon: 'en_us',
      accessThisContent: {
        name: 'Preview: Access this content',
        controlType: 'button'
      }
    },
    didYouKnowData: {
      eyProduct: 'Discover Reimagined',
      eyApp: 'discover-search',
      controlType: 'button',
      event: 'clickAction',
      name: 'Did you know?',
      type: 'o',
      browse: 'Browse Results Page',
      search: 'Search Results Page'
    },
    Download: {
      event: 'contentDownload',
      name: 'Content Download:',
      type: 'download'
    },
    Bestbets: {
      event: 'clickAction',
      locationInPage: 'Best Bets',
      type: 'other',
      eyProduct: 'Discover Reimagined',
      eyApp: 'discover-search',
      controlType: 'link',
      language: 'en_us'
    },
    insightsClick: {
      event: 'clickAction',
      locationInPage: 'Insights',
      type: 'other',
      eyProduct: 'Discover Reimagined',
      eyApp: 'discover-search'
    },
    relatedSearches: {
      event: 'clickAction',
      webInteraction: {
        name: 'Related Searches',
        type: 'other'
      },
      etassureco: {
        linkId: 'Search result page',
        controlType: 'button',
        eyProduct: 'Discover Reimagined',
        eyApp: 'discover-search'
      }
    },
    browseConfigs: {
      proposals: 'Proposals',
      policyfinder: 'Policy Finder',
      solutions: 'Solutions',
      credentials: 'Credentials',
      eypkc: 'EY-Parthenon Knowledge Capture',
      'rm-topics': 'Risk Management Topics'
    },
    documentDownloadAndShareLink: {
      browse: 'Browse Results Page',
      search: 'Search Results Page',
      event: 'clickAction',
      type: 'other',
      controlType: 'icon',
      eyProduct: 'Discover Reimagined',
      eyApp: 'discover-search',
      language: 'en_us',
      locationInPage: 'Discover Search Results: Ellipsis',
      locationInPageBrowse: ' browse search results: Ellipsis',
      ellipsisDownload: ': Download',
      ellipsisShare: ': Share link'
    }
  },
  refinerLimits: {
    default: 4,
    News: 5
  },
  peopleFieldsToHighlight: ['aboutme', 'usercvs'],
  noOfItemsPerPage: 'noOfItemsPerPage',
  defaultItemsPerPage: 12,
  BestBets: 'BestBets',
  EYPKC: 'eypkc',
  RefinerName: 'DiscoverReimagined',
  intranet: 'intranet',
  intranetAnalytics: 'Intranet', // We are using this only for analytics purposes, as the Analytics requirement expects the values in different letter cases. Please do not use this in other code.
  InsightsData: 'InsightsPane',
  ElasticFields: {
    vertical: 'ESC_VERTICAL'
  },
  searchType: {
    Semantic: 'Semantic',
    Keyword: 'Keyword'
  },
  semanticTooltipText: 'Click to activate Beta Search and get your results powered by AI',
  keywordTooltipText: 'Click to activate keyword search',
  aiSearchToggleLabel: 'Beta Search',
};

export { appConstants };
